<t4-container title="{{'Turbo.Reports.CSEventlogDialog.TitleCustomerSupportEvents' | translate : 'Customer support events '}} - {{ rentalId }}">
  <mat-spinner style="margin:auto;" *ngIf="loading"></mat-spinner>
  <t4-data-table #tbl headline="" matSort [rawData]="eventData" [filterFields]="['Note', 'TimeSpan']" [autoGenerateColumns]="false" [allowFilter]="false" [allowExcel]="false" [allowPaging]="false">
    <ng-container matColumnDef="TimeSpan">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:200px; font-weight:bold;">{{'Turbo.Reports.CSEventlogDialog.lblTimeStamp' | translate : 'Timestamp'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:200px">{{ row.TimeStamp | date : 'd MMM y, HH:mm:ss'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Note">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight:bold;">{{'Turbo.Reports.CSEventlogDialog.lblNote' | translate : 'Note'}}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Note }}</mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
